export enum QuestionnaireType {
  /** ePRO */
  ECOA = 'ECOA',
  /** ClinRO */
  CLINRO = 'CLINRO',
  HEALTH_EVENT = 'HEALTH_EVENT',
  DIARY = 'DIARY',
  ENGAGEMENT = 'ENGAGEMENT',
  /** Customer Satisfaction Score (non-clinical) */
  CSAT = 'CSAT',
  /** Study Participant Feedback Questionnaire (non-clinical) */
  SPFQ = 'SPFQ',
  /** Usability Metric for User Experience (non-clinical) */
  UMUX = 'UMUX',
  TRAINING = 'TRAINING',
  UNKNOWN = 'UNKNOWN',
}
